import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

/**
 *
 */
@Component({
  standalone: false,
  selector: 'app-san-checkbox',
  templateUrl: './san-checkbox.component.html',
  styleUrls: ['./san-checkbox.component.scss']
})
export class SanCheckboxComponent {
  @Input() isChecked = false;
  @Input() isDisabled = false;
  @Output() changeCheckbox = new EventEmitter<boolean>();
  /**
   *
   */
  constructor() { }
}
